// extracted by mini-css-extract-plugin
module.exports = {"cls1":"JsDocTitleSignature-CssProp1_div-module--cls1--3PUvR","cls2":"JsDocTitleSignature-CssProp1_div-module--cls2--3_gOf JsDocTitleSignature-CssProp1_div-module--cls1--3PUvR"};